import VueRouter from 'vue-router';
import Vue from 'vue'
import store from "../store";
import Helpers from "@/lib/helpers";
import basicGuard from "./basic-guard";
import helpers from "@/lib/helpers";
import qs from 'qs';
import {stringifyQuery} from "@/lib/stringify-query";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: {name: 'dashboard'}
    },
    {
        path: '/',
        redirect: {name: 'dashboard'}
    },

    {
        path: '/research',
        name: 'research',
        meta: {
            nonav: true,
        },
        component: () => import('../components/research/research.vue')
    },

    {
        path: '/chat/:conversation?',
        name: 'chat',
        meta: {guard: {permission: 'chat.use'}},
        beforeEnter: basicGuard,
        component: () => import('../components/chat/chat.vue')
    },

    {
        path: '/login',
        component: () => import("../components/login/login-main.vue"),
        name: 'login',
        meta: {
            noauth: true,
            nonav: true
        }
    },
    {
        path: '/data',
        component: () => import("../components/layout/json-viewer.vue"),
        name: 'data',
        beforeEnter: basicGuard,
    },
    {
        path: '/transaction',
        component: () => import("../components/transaction/transaction-lookup.vue"),
        name: 'transaction-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'transactions.index'
            }
        },
    },
    {
        path: '/vendor',
        component: () => import("../components/vendor/vendor-lookup.vue"),
        name: 'vendor-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'vendors.index'
            }
        },
    },
    {
        path: '/vendor/:id',
        component: () => import("../components/vendor/vendor.vue"),
        name: 'vendor',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'vendor',
                endpoint: '/api/vendor/',
                append: '',
                permission: 'vendors.read'
            }
        },
    },
    {
        path: '/customer',
        component: () => import("../components/customer/customer-lookup.vue"),
        name: 'customer-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'customers.index'
            }
        },
    },
    {
        path: '/customer/:id',
        component: () => import("../components/customer/customer.vue"),
        name: 'customer',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'customer',
                endpoint: '/api/customer/',
                append: '',
                permission: 'customers.read'
            }
        },
    },
    {
        path: '/item',
        component: () => import("../components/item/item-lookup.vue"),
        name: 'item-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'items.index'
            }
        },
    },
    {
        path: '/item/:id',
        component: () => import("../components/item/item.vue"),
        name: 'item',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'item',
                endpoint: '/api/item/',
                append: '',
                permission: 'items.read'
            }
        },
    },
    {
        path: '/listing-station',
        // both halves of the flow: the saved report picked in the header
        // decides whether it generates listings or approves them
        component: () => import("../components/auction/listing-station.vue"),
        name: 'listing-station',
        // the old paths still work - people have these bookmarked
        alias: ['/listing-workstation', '/listing-qc'],
        beforeEnter: basicGuard,
        meta: {
            nonav: true,
            guard: {
                // generating needs auctions.create and approving needs
                // auctions.review; the picker only offers the group the user
                // can actually act on, so the route itself takes either
                permission: ['auctions.create', 'auctions.review']
            }
        },
    },
    {
        path: '/item/:id/auction',
        component: () => import("../components/auction/auction.vue"),
        name: 'item-auction-edit',
        beforeEnter: basicGuard,
        meta: {
            nonav: true,
            guard: {
                permission: 'auctions.create'
            }
        },
    },
    {
        path: '/item/audit',
        component: () => import("../components/audit/audit-review.vue"),
        name: 'item-audit',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'items.read'
            }
        },
    },
    {
        path: '/item/:id/inventory/:inventory?',
        component: () => import ('../components/item/item-inventory-full.vue'),
        name: 'item-inventory',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'item',
                endpoint: '/api/item/',
                append: '',
                permission: 'items.read'
            }
        },
    },
    {
        path: '/auction',
        component: () => import("../components/auction/auction-lookup.vue"),
        name: 'auction-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'auctions.index'
            }
        },
    },
    {
        path: '/auction/:id',
        component: () => import("../components/auction/auction-view.vue"),
        name: 'auction',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'auction',
                endpoint: '/api/auction/',
                append: '',
                permission: 'auctions.read'
            }
        },
    },
    {
        path: '/auction/:id/allocation',
        component: () => import('../components/auction/auction-allocation.vue'),
        name: 'auction-allocation',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'auction',
                endpoint: '/api/auction/',
                append: '',
                permission: 'auctions.read'
            }
        },
    },
    {
        path: '/auction/edit',
        redirect: {name: 'auction-edit', params: {id: 0}}
    },
    {
        path: '/auction/:id/edit',
        alias: '/auction/edit',
        component: () => import("../components/auction/auction.vue"),
        name: 'auction-edit',
        meta: {
            nonav: true
        },
        beforeEnter(to, from, next) {
            if (!Helpers.can('auctions.create') && !Helpers.can('auctions.write') && !Helpers.can('auctions.live.write')) {
                Helpers.alert("Permission denied, requires auctions.create, auctions.write, or auctions.live.write")
                next(false)
            } else
                next()
        }
    },
    {
        path: '/offer',
        component: () => import("../components/offer/offer-lookup.vue"),
        name: 'offer-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'offers.index'
            }
        },
    },
    {
        path: '/bid',
        component: () => import("../components/bid/bid-lookup.vue"),
        name: 'bid-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'bids.index'
            }
        },
    },
    {
        path: '/bid/:id',
        component: () => import("../components/bid/bid.vue"),
        name: 'bid',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'bid',
                endpoint: '/api/bid/',
                permission: 'bids.read'
            }
        },
    },
    {
        path: '/bid/:id/lines/:line?',
        component: () => import("../components/bid/bid-lines.vue"),
        name: 'bid-lines',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'bid',
                endpoint: '/api/bid/',
                permission: 'bids.read'
            }
        },
    },
    {
        path: '/event',
        component: () => import("../components/event/event-lookup.vue"),
        name: 'event-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'events.index'
            }
        },
    },
    {
        path: '/event/:id',
        component: () => import("../components/event/event.vue"),
        name: 'event',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'event',
                endpoint: '/api/event/',
                permission: 'events.read'
            }
        },
    },
    {
        path: '/event/:id/leads/:lead?',
        component: () => import("../components/event/event-leads.vue"),
        name: 'event-leads',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'event',
                endpoint: '/api/event/',
                permission: 'events.read'
            }
        },
    },
    {
        path: '/photo-enhance/:id',
        component: () => import("../components/photos/photo-enhance.vue"),
        name: 'photo-enhance',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'photos.ai_enhance'
            }
        },
    },
    {
        path: '/mailbatch',
        component: () => import("../components/mailbatch/mailbatch-lookup.vue"),
        name: 'mailbatch-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'mail.batch.index'
            }
        },
    },
    {
        path: '/mailbatch/:id',
        component: () => import("../components/mailbatch/mailbatch.vue"),
        name: 'mailbatch',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'mailbatch',
                endpoint: '/api/mailbatch/',
                permission: 'mail.batch.read'
            }
        },
    },
    {
        path: '/po',
        component: () => import("../components/po/po-lookup.vue"),
        name: 'po-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'pos.index'
            }
        },
    },
    {
        path: '/po/:id',
        component: () => import("../components/po/po.vue"),
        name: 'po',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'po',
                endpoint: '/api/po/',
                append: '',
                permission: 'pos.read'
            }
        },
    },
    {
        path: '/po/:id/items',
        component: () => import("../components/po/po-items.vue"),
        name: 'po-items',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'po',
                endpoint: '/api/po/',
                append: '',
                permission: 'pos.read'
            }
        },
    },
    {
        path: '/user',
        component: () => import("../components/user/user-lookup.vue"),
        name: 'user-lookup',
    },
    {
        path: '/location',
        component: () => import("../components/location/location-lookup.vue"),
        name: 'location-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'locations.index'
            }
        },
    },
    {
        path: '/dashboard',
        component: () => import("../components/dashboard/dashboard.vue"),
        name: 'dashboard',
    },
    {
        path: '/quote',
        component: () => import("../components/quote/quote-lookup.vue"),
        name: 'quote-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'quotes.index'
            }
        },
    },
    {
        // before /quote/:id - the literal has to win
        path: '/quote/0',
        component: () => import("../components/quote/quote-create.vue"),
        name: 'quote-create',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'quotes.create'
            }
        },
    },
    {
        path: '/quote/:id',
        component: () => import("../components/quote/quote.vue"),
        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'quote',
                endpoint: '/api/quote/',
                append: '',
                permission: 'quotes.read'
            }
        },
    },
    {
        path: '/order',
        component: () => import("../components/order/order-lookup.vue"),
        name: 'order-lookup',
        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'orders.index'
            }
        },
    },
    {
        path: '/order/0',
        component: () => import("../components/order/order-create.vue"),
        name: 'order-create',

        beforeEnter: basicGuard,
        meta: {
            guard: {
                permission: 'orders.create'
            }
        },
    },
    {
        path: '/order/:id',
        component: () => import("../components/order/order.vue"),

        beforeEnter: basicGuard,
        meta: {
            guard: {
                type: 'order',
                endpoint: '/api/order/',
                append: '',
                permission: 'orders.read'
            }
        },
    },
    {
        path: '/timeclock/:schedule/:date(\\d{4}-\\d{1,2}-\\d{1,2})?',
        component: () => import("../components/timeclock/timeclock-summary.vue"),
        name: 'timeclock-summary',
        props: true,
        beforeEnter: basicGuard,
    },
    {
        path: '/user/:user/timecard/date/:date(\\d{4}-\\d{1,2}-\\d{1,2})',
        component: () => import("../components/timeclock/user-timecard.vue"),
        name: 'user-timecard',
        props: true,
        beforeEnter: basicGuard,
    },
    {
        // config keys edited in OMS instead of config.php; each section checks its own permission
        path: '/system/config',
        component: () => import('../components/system/config/config-settings.vue'),
        name: 'system-config',
        beforeEnter: basicGuard,
    },
    {
        path: '/system/relay',
        component: () => import('../components/system/relay-service.vue'),
        name: 'relay-service',
        beforeEnter: basicGuard,
    },
    {
        // the receiving-bench question scripts that seed listing copy
        path: '/setup/receiving-scripts',
        component: () => import('../components/listing/listing-scripts.vue'),
        name: 'receiving-scripts',
        beforeEnter: basicGuard,
    },
    {
        // the flight log: FlySto's legs classified for the CPA's yearly workbook
        path: '/flights',
        component: () => import('../components/flight/flight-log.vue'),
        name: 'flights',
        props: (route) => ({flight: route.query.flight || null}),
        beforeEnter: basicGuard,
    },
    {
        path: '/report',
        component: () => import('../components/report/report-select.vue'),
        name: 'report-select',
        beforeEnter: basicGuard,
    },
    {
        path: '/report/:id',
        component: () => import('../components/report/report-input.vue'),
        name: 'report-input',
        props: true,
        beforeEnter: basicGuard,
    },
    {
        path: '/report/saved/:saved/run',
        component: () => import('../components/report/report-run.vue'),
        name: 'report-run-saved',
        props: true,
        beforeEnter: basicGuard,
    },
    {
        path: '/report/:id/run',
        component: () => import('../components/report/report-run.vue'),
        name: 'report-run',
        props: (route) => ({id: route.params.id, form: route.query}),
        beforeEnter: basicGuard,
    },
    {
        path: '/message',
        component: () => import("../components/message/message-lookup.vue"),
        name: 'message-lookup',
        beforeEnter(to, from, next) {
            if (!Helpers.can('messages.index') && !Helpers.can('messages.self')) {
                Helpers.alert("Permission denied, requires messages.index, messages.self")
                next(false)
            } else
                next()
        }
    },
    {
        path: '/redirect',
        name: 'redirect',
        component: {
            template: '<div />',
            mounted() {
                this.global_lookup(this.$route.query.q)
            }
        }
    },
    {
        path: '/:catchAll(.*)*',
        name: 'catchall',
        component: () => import('../error.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery
});

router.beforeEach(async (to, from, next) => {
    // a link from the RF app (?token=): its one-time token signs this
    // browser in as that user, whoever was signed in here before
    if (to.query.token && to.name !== 'login') {
        const {token, ...query} = to.query
        store.commit('clear_first')
        next({name: 'login', params: {url: to.path, query, token}})
        return
    }

    if (store.getters.is_first) {
        if (store.getters.isAuthenticated) {
            let result = {}
            try {
                result = await helpers.asyncAction('/api/login/check', 'GET')
            } catch {
                result.authed = false
            }
            if (!result.authed) {
                await store.commit('auth_logout')
                await next({name: 'login', params: {url: to.path, query: to.query}})
            }
        }
        store.commit('clear_first')
    }

    to.meta.leaving = false
    if (!to.meta.noauth)
        if (!store.getters.isAuthenticated) {
            next({name: 'login', params: {url: to.path, query: to.query}})
            return
        }

    next()
})

export default router